import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CarrierZipPrefixList from '../components/CarrierZipPrefixList';
import CarrierZipPrefixForm from '../components/CarrierZipPrefixForm';

const CarrierZipPrefixesPage = () => {
    return (
        <div>
            <Routes>
                <Route path="/" element={<CarrierZipPrefixList />} />
                <Route path="new" element={<CarrierZipPrefixForm />} />
                <Route path="edit/:id" element={<CarrierZipPrefixForm />} />
            </Routes>
        </div>
    );
};

export default CarrierZipPrefixesPage;